import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { take } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import telefoneVerdadeiro from '../../funcoes/validar.telefone';

@Component({
  selector: 'app-consultar-fornecedor',
  templateUrl: './consultar-fornecedor.component.html',
  styleUrls: ['./consultar-fornecedor.component.scss', '../../styles/estilo.padrao.scss']
})

export class ConsultarFornecedorComponent implements OnInit {
  uid;
  bConsulta: boolean = false;
  fornecedorForm: FormGroup;

  displayedColumns: string[] = ['CNPJ', 'RazaoSocial', 'InscricaoEstadual', 'Cidade', 'UF', 'Consultar'];
  fornecedoresSource;
  idFornecedorCadastrado;

  @ViewChild(MatPaginator) paginator: MatPaginator;


  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute

  ) {
    this.uid = localStorage.getItem('uid');
    this.spinner.show('consultar-fornecedor');

    //Pegar o fornecedor recém cadastrado
    this.activatedRoute.queryParams.subscribe(value => {
      const dado = value;
      if (dado.IDFornecedor) {
        this.idFornecedorCadastrado = dado.IDFornecedor;
      }
    });
  }

  //Máscaras
  maskTelefone = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  maskTelefone2 = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  maskCEP = [/\d/, /\d/, ".", /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/];

  ngOnInit(): void {

    this.usuarioService.getFornecedores(this.uid).pipe(take(1)).subscribe(snap => {
      this.fornecedoresSource = [];

      if (snap.length > 0) {
        let auxFornecedores: any[] = [];
        var dados;

        snap.forEach((item, index) => {
          dados = item.payload.val();

          if (item.key === this.idFornecedorCadastrado) {
            this.consultarFornecedor({
              ID: item.key,
              Status: dados.Status,
              RazaoSocial: dados.RazaoSocial,
              NomeFantasia: dados.NomeFantasia,
              CNPJ: dados.CNPJ,
              InscricaoEstadual: dados.InscricaoEstadual,
              Telefone: dados.Telefone,
              TelefoneSecundario: dados.TelefoneSecundario,
              Responsavel: dados.Responsavel,
              Observacao: dados.Observacao,
              CEP: dados.CEP,
              Logradouro: dados.Logradouro,
              Numero: dados.Numero,
              Complemento: dados.Complemento,
              Bairro: dados.Bairro,
              Cidade: dados.Cidade,
              UF: dados.UF,
              Referencia: dados.Referencia,
              TimestampCadastro: dados.TimestampCadastro,
              DataHoraCadastro: this.usuarioService.tratarDataHora(dados.TimestampCadastro)
            })
          } else
            auxFornecedores.push({
              ID: item.key,
              Status: dados.Status,
              RazaoSocial: dados.RazaoSocial,
              NomeFantasia: dados.NomeFantasia,
              CNPJ: dados.CNPJ,
              InscricaoEstadual: dados.InscricaoEstadual,
              Telefone: dados.Telefone,
              TelefoneSecundario: dados.TelefoneSecundario,
              Responsavel: dados.Responsavel,
              Observacao: dados.Observacao,
              CEP: dados.CEP,
              Logradouro: dados.Logradouro,
              Numero: dados.Numero,
              Complemento: dados.Complemento,
              Bairro: dados.Bairro,
              Cidade: dados.Cidade,
              UF: dados.UF,
              Referencia: dados.Referencia,
              TimestampCadastro: dados.TimestampCadastro,
              DataHoraCadastro: this.usuarioService.tratarDataHora(dados.TimestampCadastro)
            });
        });

        // this.usuarioService.setLog("Consulta geral de fornecedores", null, this.uid);

        this.fornecedoresSource = new MatTableDataSource(auxFornecedores);
        this.fornecedoresSource.paginator = this.paginator;

        setTimeout(() => this.spinner.hide('consultar-fornecedor'), 300);
      } else {
        this.toastr.error("Não foi possível localizar fornecedores!", 'Erro');
        setTimeout(() => this.spinner.hide('consultar-fornecedor'), 300);
      }
    });

    this.fornecedorForm = this.formBuilder.group({
      idEmpresa: ['', null],
      status: [false, null],
      razaoSocial: ['', [Validators.required]],
      nomeFantasia: ['', [Validators.required]],
      cnpj: ['', [Validators.required]],
      inscricaoEstadual: ['', Validators.required],
      telefone: ['', [Validators.required, telefoneVerdadeiro]],
      telefoneSecundario: ['', null],
      responsavel: ['', Validators.required],
      observacao: ['', null],
      cep: ['', Validators.required],
      logradouro: ['', Validators.required],
      numero: ['', Validators.required],
      complemento: ['', null],
      bairro: ['', Validators.required],
      cidade: ['', Validators.required],
      uf: ['', Validators.required],
      referencia: ['', null],
      dataCadastro: ['', null]
    });
  }

  consultarFornecedor(dados) {
    this.bConsulta = true;

    this.usuarioService.setLog("Consulta detalhada do fornecedor: " + dados.ID + ' CNPJ: ' + dados.CNPJ + ' Nome Fantasia: ' + dados.NomeFantaisa, null, this.uid);

    this.fornecedorForm.get('idEmpresa').patchValue(dados.ID);
    this.fornecedorForm.get('status').patchValue(dados.Status);
    this.fornecedorForm.get('razaoSocial').patchValue(dados.RazaoSocial);
    this.fornecedorForm.get('nomeFantasia').patchValue(dados.NomeFantasia);
    this.fornecedorForm.get('cnpj').patchValue(dados.CNPJ);
    this.fornecedorForm.get('cnpj').disable();
    this.fornecedorForm.get('inscricaoEstadual').patchValue(dados.InscricaoEstadual);
    this.fornecedorForm.get('telefone').patchValue(dados.Telefone);
    this.fornecedorForm.get('telefoneSecundario').patchValue(dados.TelefoneSecundario);
    this.fornecedorForm.get('responsavel').patchValue(dados.Responsavel);
    this.fornecedorForm.get('dataCadastro').patchValue(dados.DataHoraCadastro);

    this.fornecedorForm.get('observacao').patchValue(dados.Observacao);
    this.fornecedorForm.get('cep').patchValue(dados.CEP);
    this.fornecedorForm.get('logradouro').patchValue(dados.Logradouro);
    this.fornecedorForm.get('numero').patchValue(dados.Numero);
    this.fornecedorForm.get('complemento').patchValue(dados.Complemento);
    this.fornecedorForm.get('bairro').patchValue(dados.Bairro);
    this.fornecedorForm.get('cidade').patchValue(dados.Cidade);
    this.fornecedorForm.get('uf').patchValue(dados.UF);
    this.fornecedorForm.get('referencia').patchValue(dados.Referencia);
  }

  async atualizar() {
    this.spinner.show('default');

    if (this.fornecedorForm.valid) {
      const map = {
        Status: this.f.status.value,
        RazaoSocial: this.f.razaoSocial.value.trim(),
        NomeFantasia: this.f.nomeFantasia.value.trim(),
        InscricaoEstadual: this.f.inscricaoEstadual.value.trim(),
        Telefone: this.f.telefone.value.trim(),
        TelefoneSecundario: this.f.telefoneSecundario.value.trim(),
        Responsavel: this.f.responsavel.value.trim(),
        Observacao: this.f.observacao.value.trim(),
        CEP: this.f.cep.value.trim(),
        Logradouro: this.f.logradouro.value.trim(),
        Numero: this.f.numero.value.trim(),
        Complemento: this.f.complemento.value.trim(),
        Bairro: this.f.bairro.value.trim(),
        Cidade: this.f.cidade.value.trim(),
        UF: this.f.uf.value.trim(),
        Referencia: this.f.referencia.value.trim(),
      }

      try {
        const resp = await this.usuarioService.updateFornecedor(this.uid, this.f.idEmpresa.value, map);
        this.toastr.success('Fornecedor atualizado!', 'Status', { progressBar: true, positionClass: 'toast-top-center', });

        this.usuarioService.setLog("Alteração do fornecedor: " + this.f.idEmpresa.value + ' CNPJ: ' + this.f.cnpj.value, map, this.uid);

        setTimeout(() => {
          this.spinner.hide('default');
          this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
            this.router.navigate(["/pages/consultar-fornecedor"]));
          this.toastr.clear();
        }, 800);
      } catch (e) {
        console.log(e)
        this.spinner.hide('default');

        this.usuarioService.setLog("Erro na alteração do fornecedor: " + this.f.idEmpresa.value + ' CNPJ: ' + this.f.cnpj.value + ' Erro: ' + e, null, this.uid);

        this.toastr.error('Erro ao atualizar fornecedor!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
        this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
          this.router.navigate(["/pages/consultar-fornecedor"]));
      }
    } else {
      this.toastr.error('Preencha todos os campos corretamente!', 'Error', { progressBar: true, positionClass: 'toast-top-center', });
      this.fornecedorForm.markAllAsTouched();
      setTimeout(() => this.spinner.hide('default'), 500);
    }
  }

  async buscarCEP() {
    if (this.f.cep.value.length == 10) {
      const resp: any = await this.usuarioService.getBuscaCEP(this.f.cep.value);
      const dados = resp;

      if (dados.erro) {
        this.toastr.warning("Cep inválido!", 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
        this.fornecedorForm.get('logradouro').patchValue('');
        this.fornecedorForm.get('complemento').patchValue('');
        this.fornecedorForm.get('bairro').patchValue('');
        this.fornecedorForm.get('cidade').patchValue('');
        this.fornecedorForm.get('uf').patchValue('');
        this.fornecedorForm.get('cidade').enable();
        this.fornecedorForm.get('uf').enable();
      } else {
        this.fornecedorForm.get('logradouro').patchValue(dados.logradouro);
        this.fornecedorForm.get('complemento').patchValue(dados.complemento);
        this.fornecedorForm.get('bairro').patchValue(dados.bairro);
        this.fornecedorForm.get('cidade').patchValue(dados.localidade);
        this.fornecedorForm.get('uf').patchValue(dados.uf);
        this.fornecedorForm.get('cidade').disable();
        this.fornecedorForm.get('uf').disable();
      }
    }
  }

  aplicarFiltroTabela(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.fornecedoresSource.filter = filterValue.trim().toLowerCase();

    if (this.fornecedoresSource.paginator) {
      this.fornecedoresSource.paginator.firstPage();
    }
  }

  voltar() {
    this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/pages/consultar-fornecedor"]));
  }

  onChangeTel(e, b) {
    if (e.length >= 6) {
      if (e.substring(5, 6) === '9') {
        b ? this.maskTelefone = ['(', /\d/, /\d/, ')', ' ', '9', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] : this.maskTelefone2 = ['(', /\d/, /\d/, ')', ' ', '9', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      } else {
        b ? this.maskTelefone = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] : this.maskTelefone2 = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      }
    } else {
      b ? this.maskTelefone = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] : this.maskTelefone2 = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.fornecedorForm.controls; }

  getFormValue(form) { return this.fornecedorForm.get(form).value; }
}
